/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Header = styled.div`
  padding-left: 16px;
  height: 48px;
  line-height: 48px;
  background: ${Palette.PrimaryGray._000};
  border-right: 1px solid ${Palette.PrimaryGray._200};
  display: flex;
  align-items: center;
  width: ${({ width }) => `${width}px`};
  ${({ left }) =>
    left &&
    css`
      color: ${Palette.Teal._600};
    `}
  ${({ right }) =>
    right &&
    css`
      color: ${Palette.Red._600};
    `}
`;

export const NoContent = styled.div`
  border: 1px solid ${Palette.PrimaryGray._200};
  border-left: none;
  width: 600px;
  display: flex;
  flex-direction: column;
  ${Header} {
    color: ${Palette.Teal._600};
    border-bottom: 1px solid ${Palette.PrimaryGray._200};
  }

  p {
    color: ${Palette.PrimaryGray._500};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    align-self: center;
    margin-top: 200px;
  }
  background: ${Palette.PrimaryGray._100};
`;

export const Box = styled.div`
  width: 600px;
  display: flex;
  justify-content: space-between;
  height: 100%;
  background: ${Palette.PrimaryGray._100};
  overflow-y: auto;
  max-height: 388px;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Palette.PrimaryGray._300};
    border-radius: 8px;
  }
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
`;

export const IncludeBox = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? '300px' : '100%')};
  border-right: ${({ fullWidth }) =>
    fullWidth ? `1px solid ${Palette.PrimaryGray._200}` : `none`};
  padding: 16px;
`;

export const ExcludeBox = styled.div`
  width: 300px;
  padding: 16px;
`;

export const HeaderWrap = styled.div`
  display: flex;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-left: none;
`;

///SelectedItem
export const ItemContainer = styled.div`
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  background: #fff;
  height: 32px;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  padding-left: 8px;
  margin-top: 2px;
`;

//ItemName
export const HighlightedText = styled.span`
  font-size: 12px;
  line-height: 16px;
  font-style: normal;
  font-weight: 400;
  ${({ env }) => {
    if (env === 'include')
      return css`
        color: ${Palette.Teal._600};
      `;
    if (env === 'exclude')
      return css`
        color: ${Palette.Red._600};
      `;
  }}
`;

export const StrongText = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const ItemBox = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;
